import { TEventJournalQuery, TEventType } from '@entities/eventJournal/model/types';
import { useNuqsArrayQueryState } from '@shared/hooks';

interface IUseGetFilterNames {
    queryKey: TEventJournalQuery;
    filterData: TEventType[];
}

export const useGetFilterNames = ({ queryKey, filterData }: IUseGetFilterNames) => {
    const { state } = useNuqsArrayQueryState(queryKey);

    return state?.map((val) => filterData?.find((item) => String(item.id) === val)?.name);
};
